import { z } from 'zod'
import FormWrapper from 'app/frontend/base/components/FormWrapper'
import { usePageInfo } from 'app/frontend/base/config/queries'
import SettingField from 'app/frontend/base/components/form-fields/SettingField'
import { zSetting } from 'app/frontend/base/helpers/forms'
import { useQueryClient } from '@tanstack/react-query'

const formSchema = z.object({
  settings: z.object({
    battletagVisibility: zSetting(z.string()),
    altVisibility: zSetting(z.string()),
    allowCharactersBeingTracked: zSetting(z.string()),
  }),
})

const UserSettingsPrivacySection = () => {
  const queryClient = useQueryClient()
  const {
    data: { user },
  } = usePageInfo()

  if (!user) return null

  return (
    <FormWrapper
      formSchema={formSchema}
      entityType='user'
      entity={user}
      onSave={async (form, data) => {
        form.reset(data)
        await queryClient.invalidateQueries({ queryKey: ['pageInfo'] })
      }}
    >
      <SettingField name='battletagVisibility' />
      <SettingField name='altVisibility' />
      <SettingField name='allowCharactersBeingTracked' />
    </FormWrapper>
  )
}

export default UserSettingsPrivacySection
